import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Navbar.css";
import logo from "../../images/logo.png";
import {
  FaChevronDown,
  FaChevronRight,
  FaGraduationCap,
  FaBook,
  FaAward,
  FaStar,
  FaRegStar,
  FaLaptopCode,
  FaBookReader,
  FaChartLine,
  FaGift,
  FaTrophy,
  FaSchool,
  FaComments
} from "react-icons/fa";

function Navbar() {
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [subDropdownOpen, setSubDropdownOpen] = useState(false);

  // States for Services Dropdown Menus
  const [featuredSubOpen, setFeaturedSubOpen] = useState(false);
  const [nonFeaturedSubOpen, setNonFeaturedSubOpen] = useState(false);

  // States for Courses Dropdown Menus
  const [coursesDropdownOpen, setCoursesDropdownOpen] = useState(false);
  const [scholasticSubOpen, setScholasticSubOpen] = useState(false);
  const [competitiveSubOpen, setCompetitiveSubOpen] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg crest-navbar sticky-top">
      <div className="container my-5 crest-navbar-container">
        <NavLink className="navbar-brand" to="/">
          <img src={logo} alt="Crestest Logo" className="crest-logo" />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-controls="navbarNav"
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse justify-content-end ${mobileMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav align-items-lg-center">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={() => setMobileMenuOpen(false)}>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={() => setMobileMenuOpen(false)}>
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/unique-features" onClick={() => setMobileMenuOpen(false)}>
                Unique Features
              </NavLink>
            </li>

            {/* --- Courses Dropdown Menu Item with Multi-Level Submenus --- */}
            <li
              className="nav-item dropdown crest-custom-dropdown"
              onMouseEnter={() => setCoursesDropdownOpen(true)}
              onMouseLeave={() => {
                setCoursesDropdownOpen(false);
                setScholasticSubOpen(false);
                setCompetitiveSubOpen(false);
              }}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle-custom btn-reset ${window.location.pathname.startsWith('/courses') ? 'services-link-active' : ''}`}
                onClick={() => setCoursesDropdownOpen(!coursesDropdownOpen)}
              >
                Courses <FaChevronDown className="ms-1 dropdown-indicator-icon" />
              </button>

              {/* Tier 1 Courses Dropdown Menu Panel */}
              <ul className={`crest-dropdown-menu ${coursesDropdownOpen ? 'show-menu' : ''}`}>

                {/* Nested Scholastic Submenu Parent */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setScholasticSubOpen(true);
                    setCompetitiveSubOpen(false);
                  }}
                  onMouseLeave={() => setScholasticSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setScholasticSubOpen(!scholasticSubOpen);
                    setCompetitiveSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-blue me-3"><FaBook /></span>
                      <span className="item-text">Scholastic</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${scholasticSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  {/* Tier 2 Scholastic Sub-Dropdown Panel */}
                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${scholasticSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="https://cbse.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setCoursesDropdownOpen(false);
                          setScholasticSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3">
                          <FaGraduationCap />
                        </span>
                        <span className="item-text">CBSE</span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="https://icse.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setCoursesDropdownOpen(false);
                          setScholasticSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3">
                          <FaGraduationCap />
                        </span>
                        <span className="item-text">ICSE</span>
                      </a>
                    </li>
                  </ul>
                </li>

                {/* Nested Competitive Submenu Parent */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setCompetitiveSubOpen(true);
                    setScholasticSubOpen(false);
                  }}
                  onMouseLeave={() => setCompetitiveSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCompetitiveSubOpen(!competitiveSubOpen);
                    setScholasticSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-yellow me-3"><FaAward /></span>
                      <span className="item-text">Competitive</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${competitiveSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  {/* Tier 2 Competitive Sub-Dropdown Panel */}
                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${competitiveSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <a
                        className="crest-dropdown-item"
                        href="https://ntse.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setCoursesDropdownOpen(false);
                          setCompetitiveSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3">
                          <FaGraduationCap />
                        </span>
                        <span className="item-text">NTSE</span>
                      </a>
                    </li>
                  </ul>
                </li>

              </ul>
            </li>

            {/* --- Updated Services Dropdown Menu Item --- */}
            <li
              className="nav-item dropdown crest-custom-dropdown"
              onMouseEnter={() => setServicesDropdownOpen(true)}
              onMouseLeave={() => {
                setServicesDropdownOpen(false);
                setFeaturedSubOpen(false);
                setNonFeaturedSubOpen(false);
              }}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle-custom btn-reset ${window.location.pathname.startsWith('/services') ? 'services-link-active' : ''}`}
                onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)}
              >
                Services <FaChevronDown className="ms-1 dropdown-indicator-icon" />
              </button>

              {/* Tier 1 Dropdown Menu Panel */}
              <ul className={`crest-dropdown-menu ${servicesDropdownOpen ? 'show-menu' : ''}`}>

                {/* Nested Featured Services Submenu Parent */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setFeaturedSubOpen(true);
                    setNonFeaturedSubOpen(false);
                  }}
                  onMouseLeave={() => setFeaturedSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFeaturedSubOpen(!featuredSubOpen);
                    setNonFeaturedSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-blue me-3"><FaStar /></span>
                      <span className="item-text">Featured services</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${featuredSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  {/* Tier 2 Featured Services Sub-Dropdown Panel */}
                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${featuredSubOpen ? 'show-submenu' : ''}`}>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/online-exam"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaLaptopCode /></span>
                        <span className="item-text">Online exam</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/e-library"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaBookReader /></span>
                        <span className="item-text">E library</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/performance-scorecard"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaChartLine /></span>
                        <span className="item-text">Performance scorecard</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* Nested Non Featured Services Submenu Parent */}
                <li
                  className="dropdown-submenu-parent"
                  onMouseEnter={() => {
                    setNonFeaturedSubOpen(true);
                    setFeaturedSubOpen(false);
                  }}
                  onMouseLeave={() => setNonFeaturedSubOpen(false)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setNonFeaturedSubOpen(!nonFeaturedSubOpen);
                    setFeaturedSubOpen(false);
                  }}
                >
                  <div className="crest-dropdown-item submenu-trigger">
                    <div className="d-flex align-items-center">
                      <span className="dropdown-icon-box accent-teal me-3"><FaRegStar /></span>
                      <span className="item-text">Non Featured services</span>
                    </div>
                    <FaChevronRight className={`sub-indicator-icon ${nonFeaturedSubOpen ? 'rotate-icon' : ''}`} />
                  </div>

                  {/* Tier 2 Non Featured Services Sub-Dropdown Panel */}
                  <ul className={`crest-sub-dropdown-menu sub-dropdown-flip ${nonFeaturedSubOpen ? 'show-submenu' : ''}`}>
                    {/* <li>
                      <a
                        href="https://crestestlearning.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="crest-dropdown-item"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3"><FaGift /></span>
                        <span className="item-text">Freemium</span>
                      </a>
                    </li> */}
                    {/* <li>
                      <a
                        href="https://kirnavali.crestestlearning.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="crest-dropdown-item"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-blue me-3"><FaTrophy /></span>
                        <span className="item-text">Kirnavali program</span>
                      </a>
                    </li> */}
                    <li>
                      <a
                        href="https://school.crestest.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="crest-dropdown-item"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-teal me-3"><FaSchool /></span>
                        <span className="item-text">School erp</span>
                      </a>
                    </li>
                    <li>
                      <NavLink
                        className="crest-dropdown-item"
                        to="/forum"
                        onClick={() => {
                          setServicesDropdownOpen(false);
                          setNonFeaturedSubOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        <span className="dropdown-icon-box accent-yellow me-3">
                          <FaComments />
                        </span>
                        <span className="item-text">Forum</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

              </ul>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={() => setMobileMenuOpen(false)}>
                Contact
              </NavLink>
            </li>

             <li className="nav-item">
              <NavLink className="nav-link" to="/associates" onClick={() => setMobileMenuOpen(false)}>
                Associates
              </NavLink>
            </li>

            {/* --- New Login Button Item --- */}
            <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
              <a
                href="https://lms.crestest.com/page-login"
                target="_blank"
                rel="noopener noreferrer"
                className="btn crest-login-btn"
                onClick={() => setMobileMenuOpen(false)}
              >
                Login
              </a>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;